import styled, { css } from 'styled-components';
import AuthorTime from 'components/AuthorTime';
import { TitleAndAction, ActionButton, ButtonReset } from 'ui';
import { MdCheck } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const AddMemberButton = styled(ButtonReset)`
  display: flex;
  width: 100%;
  justify-content: space-between;

  ${({ isActive }) =>
    isActive &&
    css`
      cursor: default;
    `}
`;

const NewConversationResultMemberCard = ({
  avatarUrl,
  displayName,
  onAdd,
  isActive,
  topPlaceRole,
}) => {
  const { t } = useTranslation('jobSlang');

  return (
    <TitleAndAction>
      <AddMemberButton
        isActive={isActive}
        onClick={isActive ? undefined : onAdd}
      >
        <AuthorTime
          author={{ displayName, avatarUrl, topPlaceRole }}
          small
          timestamp={t(topPlaceRole)}
          timestampIsActuallyNotATimestampSorryFolks
        />
        {isActive && (
          <ActionButton as="span" isReadOnly>
            <MdCheck />
          </ActionButton>
        )}
      </AddMemberButton>
    </TitleAndAction>
  );
};

export default NewConversationResultMemberCard;
